(() => {
  if (window.ffCollectionActionsInitialized) return;
  window.ffCollectionActionsInitialized = true;

  const openerByDialog = new WeakMap();
  const productByDialog = new WeakMap();
  const initializedDialogs = new WeakSet();
  const initializedForms = new WeakSet();
  const dialogSelector = '[data-ffc-trial-dialog], [data-ffc-bulk-dialog]';
  const whatsappUrl = 'https://wa.me/917304430014';

  const safeUrl = (value, sameOrigin = false) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (sameOrigin && url.origin !== window.location.origin) return '';
      return url.href;
    } catch {
      return '';
    }
  };

  const normalizePhone = (value) => {
    const raw = value.trim();
    if (!raw || !/^[+\d\s().-]+$/.test(raw)) return '';
    let compact = raw.replace(/[\s().-]/g, '');
    if (compact.startsWith('00')) compact = `+${compact.slice(2)}`;
    if (/^[6-9]\d{9}$/.test(compact)) return `+91${compact}`;
    if (/^0[6-9]\d{9}$/.test(compact)) return `+91${compact.slice(1)}`;
    if (/^91[6-9]\d{9}$/.test(compact)) return `+${compact}`;
    if (compact.startsWith('+91')) return /^\+91[6-9]\d{9}$/.test(compact) ? compact : '';
    return /^\+[1-9]\d{7,14}$/.test(compact) ? compact : '';
  };

  const clearPreparedMessage = (form) => {
    const message = form.querySelector('[data-ffc-whatsapp-message]');
    const status = form.querySelector('[data-ffc-whatsapp-status]');
    const retry = form.querySelector('[data-ffc-whatsapp-retry]');
    if (message) message.value = '';
    if (status) status.hidden = true;
    if (retry) retry.href = whatsappUrl;
  };

  const clearForm = (form) => {
    form.reset();
    clearPreparedMessage(form);
    form.querySelectorAll('input, textarea').forEach((input) => {
      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
    });
    const phoneError = form.querySelector('[data-ffc-mobile-error]');
    if (phoneError) {
      phoneError.textContent = '';
      phoneError.hidden = true;
    }
  };

  const updateContext = (dialog, card) => {
    if (!dialog || !card) return;
    const title = card.dataset.productTitle || '';
    const productUrl = safeUrl(card.dataset.productUrl || '', true);
    const imageUrl = safeUrl(card.dataset.productImage || '');
    const variant = card.querySelector('select[name="id"]');
    const selectedOption = variant?.selectedOptions[0];
    const variantLabel = selectedOption?.textContent.trim() || '';
    const variantId = selectedOption?.value || card.querySelector('input[name="id"]')?.value || '';
    const displayVariant = variantLabel === 'Default Title' ? '' : variantLabel;
    const url = productUrl ? new URL(productUrl) : null;
    if (url && variantId) url.searchParams.set('variant', variantId);
    const fullUrl = url?.href || productUrl;
    productByDialog.set(dialog, { title, variant: displayVariant, url: fullUrl });

    dialog.querySelectorAll('[data-ffc-product]').forEach((context) => {
      context.hidden = !title;
      context.querySelector('[data-ffc-product-title]').textContent = title;
      context.querySelector('[data-ffc-product-variant]').textContent = displayVariant;
      const link = context.querySelector('[data-ffc-product-link]');
      if (fullUrl) link.href = fullUrl;
      else link.removeAttribute('href');
      const image = context.querySelector('[data-ffc-product-image]');
      image.hidden = !imageUrl;
      if (imageUrl) image.src = imageUrl;
      else image.removeAttribute('src');
    });
    dialog.querySelectorAll('[data-ffc-whatsapp-form]').forEach(clearPreparedMessage);
  };

  const prepareEnquiry = (form) => {
    clearPreparedMessage(form);
    const mobile = form.querySelector('[data-ffc-mobile]');
    const phoneError = form.querySelector('[data-ffc-mobile-error]');
    const normalizedPhone = normalizePhone(mobile.value);
    mobile.setCustomValidity(normalizedPhone ? '' : form.dataset.ffcPhoneError);
    mobile.setAttribute('aria-invalid', normalizedPhone ? 'false' : 'true');
    phoneError.textContent = normalizedPhone ? '' : form.dataset.ffcPhoneError;
    phoneError.hidden = Boolean(normalizedPhone);
    const quantityInput = form.querySelector('[data-ffc-quantity]');
    const quantity = Number(quantityInput.value);
    const validQuantity = Number.isSafeInteger(quantity) && quantity >= 1 && (form.dataset.ffcEnquiryType !== 'trial' || quantity <= 3);
    quantityInput.setCustomValidity(validQuantity ? '' : form.dataset.ffcQuantityError);
    quantityInput.setAttribute('aria-invalid', validQuantity ? 'false' : 'true');
    if (!form.reportValidity()) return false;
    mobile.value = normalizedPhone;

    const context = productByDialog.get(form.closest('dialog')) || {};
    const lines = [form.dataset.ffcGreeting, ''];
    const append = (key, value) => {
      if (value) lines.push(`${form.dataset[`ffcLabel${key}`]}: ${value}`);
    };
    append('Product', context.title);
    append('Variant', context.variant);
    append('Url', context.url);
    append('Quantity', String(quantity));
    append('Mobile', normalizedPhone);
    append('Name', form.querySelector('[data-ffc-name]').value.trim());
    append('Email', form.querySelector('[data-ffc-email]').value.trim());
    append('Notes', form.querySelector('[data-ffc-notes]').value.trim());
    lines.push('', form.dataset.ffcMessageNote);
    const text = lines.join('\n');
    form.querySelector('[data-ffc-whatsapp-message]').value = text;
    const retryUrl = new URL(whatsappUrl);
    retryUrl.searchParams.set('text', text);
    form.querySelector('[data-ffc-whatsapp-retry]').href = retryUrl.href;
    form.querySelector('[data-ffc-whatsapp-status-text]').textContent = form.dataset.ffcStatus;
    form.querySelector('[data-ffc-whatsapp-status]').hidden = false;
    return true;
  };

  const initializeForm = (form) => {
    if (initializedForms.has(form)) return;
    initializedForms.add(form);
    form.addEventListener('input', (event) => {
      clearPreparedMessage(form);
      if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
      event.target.removeAttribute('aria-invalid');
      if (event.target.matches('[data-ffc-mobile]')) {
        const phoneError = form.querySelector('[data-ffc-mobile-error]');
        phoneError.textContent = '';
        phoneError.hidden = true;
      }
    });
    form.addEventListener('invalid', (event) => event.target.setAttribute('aria-invalid', 'true'), true);
    form.addEventListener('submit', (event) => {
      if (!prepareEnquiry(form)) event.preventDefault();
    });
    form.querySelector('[data-ffc-whatsapp-submit]').disabled = false;
  };

  const closeDialog = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  const initializeDialog = (dialog) => {
    dialog.querySelectorAll('[data-ffc-whatsapp-form]').forEach(initializeForm);
    if (initializedDialogs.has(dialog)) return;
    initializedDialogs.add(dialog);
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-ffc-close]')) {
        closeDialog(dialog);
        return;
      }
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => {
      dialog.querySelectorAll('[data-ffc-whatsapp-form]').forEach(clearForm);
      if (!document.querySelector('[data-ffc-actions] dialog[open]')) document.documentElement.classList.remove('ffc-action-open');
      const opener = openerByDialog.get(dialog);
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  };

  const openDialog = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    initializeDialog(dialog);
    document.querySelectorAll('[data-ffc-actions] dialog[open]').forEach((other) => {
      if (other !== dialog) closeDialog(other);
    });
    if (opener) openerByDialog.set(dialog, opener);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('ffc-action-open');
    const body = dialog.querySelector('.ffc-action-dialog__body');
    if (body) body.scrollTop = 0;
    return true;
  };

  const initialize = () => document.querySelectorAll(dialogSelector).forEach(initializeDialog);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ffc-trial], [data-ffc-bulk]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = trigger.closest('.shopify-section')?.querySelector('[data-ffc-actions]') || document.querySelector('[data-ffc-actions]');
    if (!root) return;
    const isTrial = trigger.hasAttribute('data-ffc-trial');
    const dialog = root.querySelector(isTrial ? '[data-ffc-trial-dialog]' : '[data-ffc-bulk-dialog]');
    updateContext(dialog, trigger.closest('article.ffc-card'));
    if (openDialog(dialog, trigger)) event.preventDefault();
  });

  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pagehide', () => document.querySelectorAll('[data-ffc-whatsapp-form]').forEach(clearForm));
  window.addEventListener('pageshow', () => {
    if (!document.querySelector('[data-ffc-actions] dialog[open]')) document.documentElement.classList.remove('ffc-action-open');
    initialize();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
